module.exports = __webpack_public_path__ + "img/color-companion-1_cn.d7ba2ee.jpg";